import store from '../store/store'

export const checkCourseAvailable = (to, from, next) => {
  if (!to.params.course_id) {
    return next()
  }

  let courseId = to.params.course_id

  axios.get('/user/associate-course/check/' + courseId).then(response => {
    if (response.data.success && response.data.check) {
      return next()
    }

    return next({ name: 'course-list' })
  }).catch(console.error)
}
